import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {IPlayerProfileResponse } from '../../views/leaguesHome/tournaments/tournamentsDetails/matches/matchesDetails/types/playerProfile';

export interface UserProfileState {
  playerProfile : IPlayerProfileResponse | null
}

const initialState: UserProfileState = {
    playerProfile : null
}


const userProfileSlice = createSlice({
    name : 'userProfile',
    initialState,
    reducers: {
        setProfile(state,action: PayloadAction<IPlayerProfileResponse>){
            state.playerProfile = action.payload;
        },
        resetUser(){
            return initialState;
        }
    }
})

export const {
    setProfile,
    resetUser
} = userProfileSlice.actions;

export default userProfileSlice.reducer;